import { useEffect } from 'react'

import { useStore } from '@/domain/state/index'
import { useState } from 'react'

interface UseBannerResults {
  showBanner: boolean
  handleCloseBanner: () => void
}

export function useBannerVisibility(id: string): UseBannerResults {
  const { bannerVisibilityStatus, closeBanner } = useStore((state) => state.bannersVisibility)

  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    setShowBanner(process.env.NEXT_PUBLIC_FEATURE_TOP_BANNER === '1' && (bannerVisibilityStatus[id] ?? true))
  }, [bannerVisibilityStatus, id])

  return {
    showBanner,
    handleCloseBanner: () => {
      closeBanner(id)
    },
  }
}
